export default __webpack_public_path__ + "static/media/mailicon.3a36266c.svg";